import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ProcessFlowchartEditorConfigurator, WorkflowFeature} from './ProcessFlowchartEditorConfigurator';

export interface DefaultFlowchartTaskSchemaEditorOptions {}

/**
 * Default FlowchartTaskSchema editor configurator
 */
export class DefaultFlowchartTaskSchemaEditorConfigurator extends ProcessFlowchartEditorConfigurator<DefaultFlowchartTaskSchemaEditorOptions> {
  allowedNodeExecutionTypes(): Array<ProcessExecutionType> {
    return [ProcessExecutionType.DIRECT, ProcessExecutionType.ENTRY, ProcessExecutionType.FLOWCHART];
  }

  enabledWorkflowsFeatures(): Array<WorkflowFeature> {
    return [
      WorkflowFeature.CUSTOMIZE_TRANSITION_SOURCE,
      WorkflowFeature.ENABLE_LOGIC_NODES,
      WorkflowFeature.ALLOW_TRANSITIONS_FOR_EXECUTION_FLEXIBILITY,
    ];
  }
}
